import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { CHARGERS, FUEL, POWER_GENERATION } from "../../../utils/constants";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";

export function useHeaderLogic(isMobile: boolean, collapsed: boolean) {
    const location = useLocation();
    const { chargerId: chargerIdFromURL, powerId: powerIdFromURL, fuelId }: any = useParams();

    const lastSegment = useMemo(() => {
        const currentPathSegments: any = location.pathname.split("/");
        let segment = currentPathSegments.at(-1);

        if (fuelId) {
            segment = FUEL;
        } else if (powerIdFromURL) {
            segment = POWER_GENERATION;
        } else if (chargerIdFromURL) {
            segment = CHARGERS;
        }

        return segment;
    }, [location.pathname, fuelId, powerIdFromURL, chargerIdFromURL]);

    const mobileIcon = isMobile ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />;
    const nonMobileIcon = isMobile ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />;

    return { lastSegment, mobileIcon, nonMobileIcon };
}